import { uniqBy } from 'lodash';
import promotionTypes from '@enums/promotion-types';
import pogScope from '@enums/product-offer-group-scope';

function getLockedCategories({ promotion, productOfferGroup, hierarchyConfig, userCategoryKeys }) {
    if (promotion.promotionType === promotionTypes.attributeScoped) {
        return [];
    }

    if (productOfferGroup.scope === pogScope.categoryWide) {
        return productOfferGroup.userSelectedCategories.filter(
            c => !userCategoryKeys.includes(c.levelEntryKey)
        );
    }

    return uniqBy(
        promotion.products
            .filter(p => productOfferGroup.products.includes(p.productKey))
            .map(product =>
                product.hierarchy.find(item => item.level === hierarchyConfig.categoryLevel)
            ),
        'levelEntryKey'
    );
}

export default {
    getLockedCategories,
};
